import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from '../../../../../utils/LoadingSpinner';

class MenuItemComboItem extends Component {

    state = {
        loading: false,
    }


    render() {
        if(this.state.loading){
            return (
                <LoadingSpinner />
            )
        }
        const props = this.props;
        return (
            <button className={`btn btn-success w-100 py-2 mb-3 d-inline-flex align-items-center ${this.props.selectedMenuItemComboItemId ===  props._id ? 'btnActiveMenuItemComboItem' : ''} `} onClick={()=>this.props.handleOnClickMenuItemComboItem(props)}>
                With {props.name}
            </button>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps,{})(MenuItemComboItem);